/**
 * Triggers a browser download for a blob via a temporary anchor element,
 * centralising the object-URL lifecycle so callers don't duplicate it.
 */
export function triggerBrowserDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
